import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import clsx from 'clsx';
import { Link } from 'gatsby';

export default function CtaButton(props) {
  const { blok } = props;
  let data = blok;
  if (!blok) {
    data = {
      style: props.style,
      title: props.title,
      url: props.url,
    };
  }
  const classNames = clsx(
    'inline-block px-[20px] py-[10px] font-monospace uppercase rounded mb-8 lg:mb-16 no-underline',
    blok?.style === 'pink' ? 'bg-latori-pink hover:bg-latori-green-dark text-white' : 'text-latori-green hover:bg-gray-100',
  );
  let url;

  if (!data?.url.url) {
    url = data.url.cached_url;
  } else {
    url = data?.url?.url;
  }

  if (!url.startsWith('/') && !url.startsWith('http')) {
    url = `/${url}`;
  }

  return (
    data?.url?.target ? (
      <a
        {...storyblokEditable(data)}
        href={url}
        target={data?.url?.target}
        className={classNames}
      >
        {data.title}
      </a>
    ) : (
      <Link
        {...storyblokEditable(data)}
        to={url}
        className={classNames}
      >
        {data.title}
      </Link>
    )
  );
}
